module.exports = __webpack_public_path__ + "static/media/biometrics_PWL.8add8150.png";